{
  "visual_age": "Visual age inferred from facial features",
  "visual_gender": "Visual gender inferred from facial features",
  "ethnicity": "Dominant facial features",
  "review": "Review status",
  "role": "The role of the talent in this asset",
  "merge_as_child": "You merge the lookalike into this talent. This talent will become the main talent, and the properties of the lookalike will be overwritten by the properties of this talent.",
  "merge_as_parent": "You merge this talent into the lookalike. The lookalike will become the main talent, and the properties of this talent will be overwritten."
}